import axios from 'axios';

let token;

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export function setToken(newToken) {
    token = newToken;
}

const urlFor = (route) =>
    `${API_BASE_URL}${route.startsWith('/') ? '' : '/'}${route}`;

const authHeaders = () =>
    (token ? { Authorization: `Bearer ${token}` } : {});

// Simple GET wrapper (existing)
export const request = async (route) => {
    const url = urlFor(route);

    if (!token) {
        console.error(`API Request token not set`);
    }

    try {
        const response = await axios.get(url, {
            headers: authHeaders(),
        });
        return response.data;
    } catch (error) {
        console.error('API Request error:', error);
        console.log(url);
        throw error;
    }
};

// New: simple POST wrapper
const post = async (route, data) => {
    const url = urlFor(route);

    if (!token) {
        console.error(`API Request token not set`);
    }

    try {
        const response = await axios.post(url, data, {
            headers: {
                'Content-Type': 'application/json',
                ...authHeaders(),
            },
        });
        return response.data;
    } catch (error) {
        console.error('API POST error:', error);
        console.log(url, data);
        throw error;
    }
};

// ===== Characters =====

export const fetchCharacter = async (characterId) => {
    const characterData = await request(`/character/${characterId}`);
    return characterData;
};

export const fetchCharacters = async () => {
    return await request('/character');
};

// Characters belonging to a specific player (scoped the same way the sidebar is).
export const fetchCharactersByPlayer = async (playerId) => {
    return await request(`/character?playerId=${playerId}`);
};

// New: create a character (expects your API POST /character to accept { name } and set defaults)
export const createCharacter = async ({ name, ...rest } = {}) => {
    if (!name) throw new Error('createCharacter requires a name');
    return await post('/character', { name, ...rest });
};

// ===== Knowledges =====

export const fetchKnowledges = async (playerId) => {
    return await request(`/knowledge`);
};

// ===== Players =====

export const fetchPlayer = async (playerId) => {
    return await request(`/player/${playerId}`);
};

// ===== Races / Skillsets =====

export const fetchRaces = async () => {
    return request('/races');
};

export const fetchSkillsets = async () => {
    return request('/skillset');
};

// ===== Transforms =====

export const fetchTransforms = async () => {
    return await request('/transforms');
};

export const fetchTransform = async (transformId) => {
    return await request(`/transforms/${transformId}`);
};

// ===== Skills =====

/**
 *
 * @param filters
 * @param filters.characterId
 * @returns {Promise<any|undefined>}
 */
export const fetchSkills = async (filters = {}) => {
    if (filters.characterId) {
        return await request(`/skill?characterId=${filters.characterId}`);
    }
};
